import { useSelector } from "react-redux";
import ColorTag from "../../common/ColorTag/ColorTag";
import { formatDate } from "src/util/date";
import { MODULE_KEY } from "./actions";
import { ACTION } from "src/util/utils";
import { SPECIAL_ORDER_QUEUE_DATA_TYPE } from "src/util/columns";

interface filterColumns {
  selectedRow: any;
  setSelectedRow: any;
  notFoundRow: any;
  setNotFoundRow: any;
  rowSelection: any;
  setRowSelection: any;
}
export default function filterColumns({
  selectedRow,
  setSelectedRow,
  notFoundRow,
  setNotFoundRow,
  rowSelection,
  setRowSelection,
}: filterColumns) {
  const notFoundCheckHandler = (
    selectedRow: any,
    notFoundSelectedRow: any,
    checked: boolean
  ) => {
    if (checked) {
      setSelectedRow(
        selectedRow.filter(
          (row: SPECIAL_ORDER_QUEUE_DATA_TYPE) =>
            row.OrderNum != notFoundSelectedRow.OrderNum
        )
      );

      var rowSelectionIds = Object.keys(rowSelection).filter(
        (id) => data[parseInt(id)].OrderNum != notFoundSelectedRow.OrderNum
      );
      const newRowSelection: any = [];
      rowSelectionIds.forEach((rowSelectionId) => {
        const rowData = rowSelection[rowSelectionId];
        if (rowData) {
          newRowSelection[rowSelectionId] = rowData;
        }
      });

      setRowSelection(newRowSelection);
      setNotFoundRow([...notFoundRow, notFoundSelectedRow]);
    } else {
      setNotFoundRow(
        notFoundRow.filter(
          (row: SPECIAL_ORDER_QUEUE_DATA_TYPE) =>
            row.OrderNum != notFoundSelectedRow.OrderNum
        )
      );
    }
  };

  const collectionName: any[] = [];
  const orDate: any[] = [];
  const { data, loading } = useSelector(
    (state: any) => state[`${MODULE_KEY}${ACTION.STATE_KEY}`]
  );
  data.forEach((row: any) => {
    if (row.FrameCollection) {
      collectionName.push({
        text: row.FrameCollection,
        value: row.FrameCollection,
      });
    }

    if (row.OrderDate) {
      const formatted = formatDate(row.OrderDate);
      orDate.push({ text: formatted, value: formatted });
    }
  });

  const frameCollectionName = collectionName.filter(
    (ele, ind) => ind === collectionName.findIndex((e) => e.text === ele.text)
  );

  const orderDate = orDate.filter(
    (ele, ind) => ind === orDate.findIndex((e) => e.text === ele.text)
  );

  const columns = [
    {
      header: "OFFICE #",
      accessorKey: "OfficeNum",
      size: 100,
      filterFn: "contains",
    },
    {
      header: "ORDER NUMBER",
      accessorKey: "OrderNum",
      size: 120,
      filterFn: "contains",
    },
    {
      header: "ORDER DATE",
      accessorKey: "OrderDate",
      size: 120,
      filterVariant: "multi-select",
      filterSelectOptions: orderDate,
      Cell: ({ cell }: any) =>
        cell.getValue() ? formatDate(cell.getValue()) : "",
    },
    {
      header: "FRAME COLLECTION",
      accessorKey: "FrameCollection",
      size: 180,
      filterVariant: "multi-select",
      filterSelectOptions: frameCollectionName,
    },
    {
      header: "VENDOR NAME",
      accessorKey: "VendorName",
      size: 140,
    },
    {
      header: "VENDOR ORD NO.",
      accessorKey: "VendorOrderNumber",
      size: 140,
    },
    {
      header: "RECEIPT NO.",
      accessorKey: "ReceiptNumber",
      size: 140,
    },
    {
      header: "FRAME NAME",
      accessorKey: "FrameName",
      size: 280,
      filterFn: "contains",
    },
    {
      header: "UPC CODE",
      accessorKey: "UPCCode",
      size: 120,
    },
    {
      header: "ITEM STATUS",
      accessorKey: "ItemStatus",
      size: 120,
    },
    {
      header: "LOCATION STATUS",
      accessorKey: "LocationStatus",
      size: 110,
    },
    {
      header: "LABEL PRINTED",
      accessorKey: "LabelPrinted",
      size: 80,
      Cell: ({ cell }: any) => {
        const status = cell.getValue() ? "Yes" : "No";
        return <ColorTag type={status.toLowerCase()}>{status}</ColorTag>;
      },
    },
  ];

  return {
    data,
    columns,
    loading,
  };
}
